import { render, staticRenderFns } from "./PageDashboard.vue?vue&type=template&id=100ef510&scoped=true"
import script from "./PageDashboard.vue?vue&type=script&lang=js"
export * from "./PageDashboard.vue?vue&type=script&lang=js"
import style0 from "./PageDashboard.vue?vue&type=style&index=0&id=100ef510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100ef510",
  null
  
)

export default component.exports